import React, { useContext, useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
	Typography,
	Button,
	CircularProgress
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import { NavLink } from "react-router-dom";

import { PageContext } from "../../contexts/PageContext";

import AddIcon from "@material-ui/icons/Add";

import ComparesList from './ComparesList';
import AddCompare from './AddCompare';
import { UserContext } from '../../contexts/UserContext';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto"
	},
	actionButtons: theme.actionButtons,
	progress: theme.progress
}));

export default function Compares(props) {
	const theme = useTheme();
	const classes = useStyles();
	const [compares, setCompares] = useState([]);
	const [addCompareDialogOpen, setAddCompareDialogOpen] = useState(false);
	const pageContext = useContext(PageContext);
	const userContext = useContext(UserContext);

	useEffect(() => {
		getCompares()
		pageContext.setIsLoading(true)

	}, []);

	const getCompares = () => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/compares`,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				setCompares(res.data);
				pageContext.setIsLoading(false);
			})
			.catch((err) => {
				console.log(err);
				pageContext.setIsLoading(false);
			});
	}

	const saveCompare = (editingCompare) => {
		// TODO add authentication
		axios.put(`${process.env.REACT_APP_API_SERVICE_URL}/compares/${editingCompare.id}`, editingCompare)
			.then((res) => {
				getCompares();
				pageContext.setInfoMessage("Kreditvergleich wurde gespeichert");
			})
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Kreditvergleich konnte nicht gespeichert werden!");
			});
	}

	const deleteCompare = (editingCompare) => {

		console.log(editingCompare)
		pageContext.setConfirmDialog({
			open: true,
			title: "Wirklich löschen?",
			message:
				"Bist du dir sicher, dass du den Kreditvergleich " +
				(editingCompare.name ? editingCompare.name : "") +
				" löschen möchtest?",
			handleYes: () => {
				pageContext.setConfirmDialog({
					open: false,
				});
				const options = {
					url: `${process.env.REACT_APP_API_SERVICE_URL}/compares/${editingCompare.id}`,
					method: 'delete',
					headers: userContext.getRequestAuthHeader()
				};
				axios(options)
					.then((res) => {
						getCompares();
						pageContext.setInfoMessage("Kreditvergleich wurde gelöscht");
					})
					.catch((err) => {
						console.log(err);
						pageContext.setErrorMessage("Kreditvergleich konnte nicht gelöscht werden!");
					});
			},
			handleNo: () => {
				pageContext.setConfirmDialog({
					open: false,
				});
			},
		});
	};

	if (!compares || pageContext.isLoading)
		return <>
			<CircularProgress
				className={classes.progress}
				color="secondary"
			/>
		</>;

	return (
		<div className={classes.root}>
			<div className={classes.actionButtons}>
				<Button
					variant="contained"
					aria-label="neuen Kreditvergleich anlegen"
					color="primary"
					size="small"
					onClick={() => {
						setAddCompareDialogOpen(true);
					}}
				>
					<AddIcon />
					neuen Kreditvergleich anlegen
				</Button>
			</div>
			<Typography variant="h2">Kreditvergleiche</Typography>
			{/* <Alert severity="warning">WICHTIG! Ab sofort muss jeder Benutzer für sich eigene Zugangsdaten zu den Banken hinterlegen. Falls du das noch nicht gemacht hast, dann <NavLink to="/benutzereinstellungen/">klick bitte hier</NavLink>.</Alert> */}
			<br />
			<ComparesList compares={compares} saveCompare={saveCompare} deleteCompare={deleteCompare} />
			<AddCompare
				newCompareCallback={
					() => {
						getCompares();
					}
				}
				addCompareDialogOpen={addCompareDialogOpen}
				setAddCompareDialogOpen={setAddCompareDialogOpen}
			/>
		</div>
	);
}
